import { FC, useRef } from 'react';
import ReactGA from 'react-ga4';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Portal from 'src/view/components/Portal/Portal';
import Text, { TEXT } from 'src/view/components/Text/Text';
import { appStore } from '~/mobx/appStore';
import { localeStore } from '~/mobx/localesStore';
import { modalStore } from '~/mobx/modalStore';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import './style.scss';

const UpdateModal: FC<{}> = () => {
  const modalRef = useRef<HTMLDivElement | null>(null);

  const handleClose = () => {
    modalStore.closeUpdateModal();
  };

  const handleUpdate = () => {
    // Send a custom event
    ReactGA.event({
      category: 'System',
      action: 'Install Update',
      label: 'Install Update', // optional
      value: 0, // optional, must be a number
      nonInteraction: true, // optional, true/false
      transport: 'xhr', // optional, beacon/xhr/image
    });
    appStore.runUpdate();
  };

  return (
    <Portal>
      <div className="update-modal">
        <div className="update-modal__backdrop" onClick={handleClose} />
        <div className="update-modal__content">
          <Icon name={Icons.ReverseArrows} size={85} color={theme.colors.mainblue} className="mt-4" />
          <Text type={TEXT.MODAL_MESSAGE} text={localeStore.t('new_version_is_available')} className="mt-8" />

          <div ref={modalRef} className="d-flex flex-column align-items-center full-width">
            <span className="update-modal__message pt-5">{localeStore.t('update_dashboard_version_message')}</span>
          </div>

          <div className="d-flex flex-column justify-content-center mt-8 gap-10">
            <Button title={localeStore.t('txt_reload')} onClick={handleUpdate} stretched />
            <Button title={localeStore.t('txt_remind_later')} onClick={handleClose} appearance="tertiary" stretched />
          </div>

          <Icon name={Icons.Close} size={14} color={theme.colors.gray2} onPress={handleClose} className="update-modal__close" />
        </div>
      </div>
    </Portal>
  );
};

export default UpdateModal;
